// src/services/reviewServices.js
import api from "../api/api";
import customerApi from "../api/CustomerApi";

export const reviewService = {
  async getProductReviews({ productId, page = 1, perPage = 10, rating = null }) {
    const params = { per_page: perPage, page };
    if (rating) params.rating = rating;

    const res = await api.get(`/products/${productId}/reviews`, { params });
    return res.data;
  },

  async createProductReview({ productId, rating, review, files = [] }) {
    const fd = new FormData();
    fd.append("rating", String(rating));
    fd.append("review", review);
    for (const f of files) fd.append("images[]", f);

    const res = await customerApi.post(`/products/${productId}/reviews`, fd);
    return res.data;
  },

  // ✅ Helpful toggle (like/unlike)
  async toggleHelpful(reviewId) {
    const res = await customerApi.post(`/reviews/${reviewId}/helpful-toggle`);
    return res.data; // { is_helpful, helpful_count }
  },
  // ✅ Update own review (FormData)
  async updateProductReview({ productId, reviewId, rating, review, files = [], removeImageIds = [] }) {
    const fd = new FormData();
    if (rating) fd.append("rating", String(rating));
    if (review !== undefined) fd.append("review", review);

    removeImageIds.forEach((id) => fd.append("remove_image_ids[]", String(id)));
    files.forEach((f) => fd.append("images[]", f));

    const res = await customerApi.post(`/products/${productId}/reviews/${reviewId}/update`, fd);
    return res.data;
  },

  // ✅ Delete own review
  async deleteProductReview({ productId, reviewId }) {
    const res = await customerApi.delete(`/products/${productId}/reviews/${reviewId}`);
    return res.data;
  },
};